import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b21bbce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pe-error-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "err-to-workflow"
}
const _hoisted_4 = {
  key: 2,
  class: "err-to-workflow text"
}
const _hoisted_5 = {
  key: 3,
  class: "bottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.isError())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.t('noAccessPermission')), 1))
        : _createCommentVNode("", true),
      (_ctx.state.isPc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t('errorPCInfo')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.t('errorMolInfo')), 1)),
      (_ctx.state.isPc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleApply && _ctx.handleApply(...args)))
            }, _toDisplayString(_ctx.t('errorToApply')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}